import type { MappedJournalRankingResponseDto } from "@lib/journalRankings";
import type { JournalItemFrequency } from "@lib/types/journals-ranking";

function frequencyLabel(frequency: JournalItemFrequency): string {
    switch (frequency) {
    case "SEMI-MONTHLY":
        return "Semi-monthly";
    case "MONTHLY":
        return "Monthly";
    case "BIMONTHLY":
        return "Bimonthly";
    case "QUARTERLY":
        return "Quarterly";
    case "IRREGULAR":
        return "Irregular";
    case "TRI-ANNUAL":
        return "Tri-annual";
    case "BIWEEKLY":
        return "Biweekly";
    case "SEMIANNUAL":
        return "Semiannual";
    case "ANNUAL":
        return "Annual";
    default:
        return "";
    }
}

export function getJournalTableItemTemplate(item: MappedJournalRankingResponseDto["rankingItems"][number]): string {
    return `
    <div class="cols journal-item rankings-content__item ">
      <span class="col col--1 col--tablet cols mx-0 py-0">
        <span class="col col--3 position px-0">
          ${item.rank}
          <span class="show-tablet desc">Rank</span>
        </span>
        <span class="col col--3 px-0 py-0 img">
          <img class="lazyload" src="${item.thumbnailUrl}" onerror="this.src='/classic-rankings-frontend/images/article-placeholder.png'" alt="${item.name}" loading="lazy" />
        </span>
      </span>
      <div class="col col--5-12 col--tablet py-0 info">
        <h4><a href="/journal/${item.slug}" title="Read more" target="_blank">${item.name}</a></h4>
        <span class="hide-tablet">
          ${item.issn ? `${item.issn}` : ""}${item.frequency ? `, ${frequencyLabel(item.frequency)}` : ""}
        </span>
      </div>
      <span class="col col--5-12 py-0 cols mx-0 rankings-info">
        <span class="col col--2 col--tablet py-0 ranking">
          <span class="show-tablet desc">Best Scientists</span>
          <span class=" ranking no-wrap">${item.bestScientists}</span>
        </span>
        <span class="col col--2 py-0 hide-tablet ranking">
          <span class=" col col--3 py-0 ranking no-wrap">${item.documents}</span>
        </span>
        <span class="col col--2 col--tablet py-0 ranking">
          <span class="show-tablet desc">D-Index</span>
          <span class=" ranking no-wrap">${item.dIndex}</span>
        </span>
      </span>
    </div>
  `;
}
